<template>
  <div>
    <el-table
      :data="data"
      style="width: 100%"
      size="medium"
      header-row-class-name="supervision-table-header"
      class="is-print-hide"
      border
    >
      <el-table-column label="药品通用名" prop="drugName"></el-table-column>
      <el-table-column label="规格" prop="drugSpec"></el-table-column>
      <el-table-column label="数量" prop="drugNum">
        <template #default="{ row: { drugNum, drugUnit } }">
          <span>{{ `${drugNum}${drugUnit || ''}` }}</span>
        </template>
      </el-table-column>
      <el-table-column label="销售时间" :min-width="100">
        <template #default="{ row: { orderTime } }">
          {{ orderTime | formatTime }}
        </template>
      </el-table-column>
      <el-table-column label="是否凭处方销售" prop="prescriptionStatus" width="200">
        <template #default="{ row: { prescriptionStatus, correctionStatus } }">
          <el-link v-if="prescriptionStatus === 0" :underline="false" type="warning">待上传</el-link>
          <el-link v-else-if="prescriptionStatus === 1" :underline="false" type="success">凭处方销售</el-link>
          <template v-else>
            <el-link :underline="false" type="danger">未凭处方销售</el-link>
            <el-tag type="success" v-if="correctionStatus == 1" size="mini">已校正</el-tag>
          </template>
        </template>
      </el-table-column>
      <el-table-column label="处方类型" prop="prescriptionCategory">
        <template #default="{ row: { prescriptionCategory } }">
          <span v-if="prescriptionCategory === 0">电子处方</span>
          <span v-else-if="prescriptionCategory === 1">线下处方</span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column label="销售订单号" prop="orderId" :min-width="180">
        <template #default="{ row: { patchedStatus, orderId } }">
          {{ orderId }}
          <el-tooltip class="item" effect="dark" content="订单非销售当日上传" placement="top-start">
            <el-tag type="danger" v-if="patchedStatus == 1" size="mini">补传</el-tag>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template
          #default="{
            row: {
              prescriptionStatus,
              prescriptionRegistrationId,
              prescriptionCategory,
              orderId,
              orderDetailId,
              drugName,
              storeName,
              orderTime,
              correctionStatus,
              correctionTime,
              correctionFileUrlList,
              correctionRemark,
              correctionTypeDesc
            }
          }"
        >
          <el-upload
            action=""
            v-if="prescriptionStatus === 0"
            accept="png,jpg,jpeg"
            :show-file-list="false"
            :http-request="e => uploadFile(e, orderId, orderDetailId)"
          >
            <el-button type="text">上传处方</el-button>
          </el-upload>
          <el-button
            type="text"
            v-else-if="prescriptionStatus === 1"
            @click="showImage({ prescriptionRegistrationId, prescriptionCategory })"
          >
            查看处方
          </el-button>
          <el-button
            type="text"
            v-else-if="correctionStatus == 1"
            @click="
              () =>
                handleClickRow({
                  orderId,
                  drugName,
                  storeName,
                  orderTime,
                  correctionTime,
                  correctionFileUrlList,
                  correctionRemark,
                  correctionTypeDesc
                })
            "
          >
            查看校正
          </el-button>
          <el-button
            type="text"
            v-else-if="correctionStatus == 0"
            @click="() => handleEditRow({ orderId, drugName, storeName, orderTime, orderDetailId })"
          >
            点击校正
          </el-button>
          <div v-else>--</div>
        </template>
      </el-table-column>
    </el-table>
    <image-viewer
      :z-index="2000"
      :initial-index="0"
      v-if="dialogVisible"
      :on-close="closeViewer"
      :url-list="[imgUrl]"
    />
    <Drawer ref="drawer" :correctionTypeCodeMap="correctionTypeCodeMap" />
    <DrawerEdit ref="drawerEdit" :correctionTypeCodeMap="correctionTypeCodeMap" @reload="$emit('update')" />
  </div>
</template>

<script>
import dayjs from 'dayjs';
import Fetch from '@/api';
import { mapGetters } from 'vuex';
import ImageViewer from '@/components/image-viewer';
import Drawer from './drawerDetail.vue';
import DrawerEdit from './drawer.vue';

export default {
  name: 'prescriptionList',
  components: { ImageViewer, Drawer, DrawerEdit },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    correctionTypeCodeMap: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialogVisible: false,
      imgUrl: ''
    };
  },
  computed: {
    ...mapGetters(['storeList']),
    storeId() {
      // 多店业务上暂时不考虑
      const { storeList } = this;
      return Array.isArray(storeList) ? storeList?.[0].id : storeList?.id;
    }
  },
  filters: {
    formatTime(val) {
      return dayjs(val).format('YYYY-MM-DD HH:mm:ss');
    },
    adaptStatus(val) {
      const statusMap = { 9: '未登记', 1: '已登记', 0: '待登记' };
      return statusMap[val];
    },
    adaptPatchStatus(val) {
      const statusMap = { 1: '补传', 0: '当日上传' };
      return statusMap[val];
    }
  },
  methods: {
    async showImage(item) {
      const { storeId } = this;
      const { prescriptionRegistrationId, prescriptionCategory } = item;
      const { prescriptionImgUrl } = await Fetch.query_prescription_img_url({
        storeId,
        prescriptionRegistrationId,
        prescriptionCategory
      });
      this.dialogVisible = true;
      this.imgUrl = prescriptionImgUrl;
    },
    async uploadFile(e, orderId, orderDetailId) {
      const { storeId } = this;

      const file = e.file;
      const fd = new FormData();
      fd.append(
        'uploadParam',
        JSON.stringify({
          appName: 'amikacin-pic',
          scene: 'prescription_file',
          bizFileName: `amikacin-prescription/${e.file.name}`,
          fileName: `amikacin-prescription/${e.file.name}`
        })
      );
      fd.append('fileStream', file);
      const {
        data: { resId }
      } = await Fetch.uploadImage(fd);

      await Fetch.pc_upload_offline_prescription({ storeId, orderId, prescriptionFileId: resId, orderDetailId });

      this.$emit('update');
    },
    closeViewer() {
      this.dialogVisible = false;
    },
    handleClickRow(row) {
      // console.log(this.$refs.drawer);
      this.$refs.drawer.init(row);
    },
    handleEditRow(row) {
      this.$refs.drawerEdit.init(row);
    }
  }
};
</script>

<style lang="scss" scoped>
.drug-item {
  position: relative;
  padding: 5px 0;

  .drug-title {
    font-weight: 500;
  }

  &:before {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 1px;
    background-color: #efefef;
  }

  &:last-child {
    &:before {
      display: none;
    }
  }
}

.red {
  color: #eb3c36;
}

.green {
  color: #1e8dff;
}

.yellow {
  color: #ebb436;
}
</style>
